<template>
  <section class="company-intro py-8">
    <v-container class="content-container">
      <v-row justify="center" class="mb-12">
        <v-col cols="12" class="text-center">
          <h2 class="text-h3 font-weight-bold">{{ $t('about.ourCompany') }}</h2>
        </v-col>
      </v-row>

      <v-row justify="center" align="start">
        <!-- 左侧图片 -->
        <v-col cols="12" md="5" class="company-image-col">
          <div class="company-image-wrapper">
            <v-img
              src="/images/about/company.jpg"
              alt="Fuhai Tonda International"
              class="company-image"
              cover
            >
              <template #placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="primary" />
                </v-row>
              </template>
            </v-img>
          </div>

          <div class="company-image-wrapper">
            <v-img
              src="/images/about/company2.jpg"
              alt="Fuhai Tonda International"
              class="company-image"
              cover
            >
              <template #placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="primary" />
                </v-row>
              </template>
            </v-img>
          </div>
        </v-col>

        <!-- 右侧内容 -->
        <v-col cols="12" md="7" class="d-flex align-start">
          <div class="company-card" flat elevation="0">
            <v-card-text class="pa-0">
              <div class="company-overview-content">
                <div class="text-body-1 company-overview-text" v-html="$t('about.companyOverview')"></div>
              </div>
            </v-card-text>
          </div>
        </v-col>
      </v-row>

      <slot name="stats" />
    </v-container>
  </section>
</template>

<script setup lang="ts">
/* Company Intro is presentational and uses i18n directly. */
</script>

<style scoped>
.company-intro { background: #fff; }

.company-card {
  border-radius: 16px;
  box-shadow: none;
  transition: all 0.3s ease;
}

.company-image-wrapper {
  position: relative;
  border-radius: 0px;
  overflow: hidden;
  box-shadow: none;
  transition: all 0.3s ease;
  width: 100%;
  align-self: flex-start;
}
.company-image-wrapper:hover { transform: translateY(-8px); }

.company-image {
  border-radius: 0px;
  transition: all 0.3s ease;
  width: 100%;
  margin-bottom: 20px;
}
.company-image-wrapper:hover .company-image { transform: scale(1.05); }

.content-container { max-width: 1400px; margin: 0 auto; }

.company-overview-text { line-height: 1.6; }
.company-overview-content div {
  margin-bottom: 2px;
  line-height: 1.6;
  font-size: 1.08rem;
  color: #222;
  font-family: 'Microsoft YaHei', 'Arial', sans-serif;
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .company-image-wrapper {
    margin-bottom: 1.5rem;
  }

  .company-image {
    margin-bottom: 15px;
  }

  .company-overview-content div {
    font-size: 0.98rem;
    line-height: 1.65;
  }

  .company-intro .text-h3 {
    font-size: 1.6rem !important;
    margin-bottom: 1.5rem !important;
  }
}

@media (max-width: 600px) {
  .company-intro {
    padding: 1.5rem 0 !important;
  }

  .company-image-wrapper {
    margin-bottom: 1rem;
  }

  .company-image {
    margin-bottom: 10px;
  }

  .company-card {
    padding: 0 0.5rem;
  }

  .company-overview-content div {
    font-size: 0.92rem;
    line-height: 1.6;
  }

  .company-intro .text-h3 {
    font-size: 1.4rem !important;
    margin-bottom: 1.2rem !important;
  }
}
</style>


